import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/contact";

const pages = {
    privacy: {
        title: "Privacy",
        lede: "What we collect when you write to us, and what we do with it. This is a plain-language notice, not a legal opinion.",
    },
    terms: {
        title: "Terms",
        lede: "How a SalesCan engagement works. A quote is not a contract until both sides agree in writing.",
    },
};

export default function LegalPage({ kind }) {
    const page = pages[kind];

    return (
        <main className="bg-white px-5 pb-20 pt-32 text-[#0a0a0b] sm:pt-36">
            <article className="mx-auto max-w-3xl">
                <p className="font-display text-xs font-bold uppercase tracking-[0.16em] text-[#2B50FF]">SalesCan</p>
                <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{page.title}</h1>
                <p className="mt-4 text-base leading-relaxed text-[#5b5b66]">{page.lede}</p>
                <div className="mt-10 space-y-8 text-sm leading-relaxed text-[#3c3c44]">
                    {kind === "privacy" ? <Privacy /> : <Terms />}
                </div>
                <p className="mt-10 text-sm text-[#5b5b66]">
                    Questions: <a className="font-semibold text-[#0a0a0b] underline underline-offset-4" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                    {" · "}
                    <Link className="font-semibold text-[#0a0a0b] underline underline-offset-4" to={kind === "privacy" ? "/terms" : "/privacy"}>
                        {kind === "privacy" ? "Terms" : "Privacy"}
                    </Link>
                </p>
            </article>
        </main>
    );
}

function Privacy() {
    return (
        <>
            <Section title="Who we are">
                SalesCan is a founder-led studio at {CONTACT.address}. Email {CONTACT.email}. Phone {CONTACT.phoneDisplay}.
            </Section>
            <Section title="What the forms collect">
                The forms on this site ask for a name, an email, a company, and what you need. Some also ask for a phone number or a short description. Submitting opens your email app with that message addressed to us. We do not keep a separate database of those form fields on the website.
            </Section>
            <Section title="How we use it">
                We use what you send to reply, to scope the work, and to send a price. We do not sell personal information. We do not add you to a marketing list because you asked for a quote. Marketing email is opt-in, with no pre-checked box.
            </Section>
            <Section title="Cookies and logs">
                This site does not run advertising cookies or a third-party analytics tag. Cloudflare, which hosts the site, may keep ordinary connection logs such as IP address and the page requested. Those logs are for security and delivery, not for building an ad profile.
            </Section>
            <Section title="Access and correction">
                You can ask what we hold from a conversation with you, and ask us to correct it, by emailing {CONTACT.email}. We will respond from St. Catharines. This notice is written for a Canadian business. It is not a legal opinion on PIPEDA, CASL, or Quebec Law 25.
            </Section>
        </>
    );
}

function Terms() {
    return (
        <>
            <Section title="Quotes">
                A price on the site, in a proposal, or on a call is an offer to discuss. Work starts when both sides agree in writing on the scope and the fee. You can walk away from a consult. The consult is free.
            </Section>
            <Section title="What you own">
                When a website or product is paid for under the agreed scope, you own that deliverable. We do not lock you into a platform you cannot leave. Monthly care, where you take it, is month to month.
            </Section>
            <Section title="The $199 website">
                That offer is one page, one revision, and a 24–48 hour turnaround, as described on the $199 page. Extra pages and extra work are quoted separately. The build starts after the $199 is paid.
            </Section>
            <Section title="Build standard">
                We check forms, consent, contrast, heading order, and keyboard access before a site launches. That is a build standard. It is not a legal opinion, and it does not make SalesCan your lawyer or your compliance officer.
            </Section>
            <Section title="Law">
                These terms are governed by the laws of Ontario and the federal laws of Canada that apply here. SalesCan is at {CONTACT.address}.
            </Section>
        </>
    );
}

function Section({ title, children }) {
    return (
        <section>
            <h2 className="font-display text-xl font-extrabold text-[#0a0a0b]">{title}</h2>
            <p className="mt-2">{children}</p>
        </section>
    );
}
